/**
 * The `src` for the enrolment QR, from whatever `qr_svg` the backend sent.
 *
 * The backend sends an inline SVG (segno) with only `width`/`height` — no
 * `xmlns`, no `viewBox`. Drawn through `<img src="data:image/svg+xml,…">`:
 *  - without the namespace the browser does not treat it as an SVG, so the QR
 *    never renders;
 *  - without a viewBox it has a fixed pixel size and is CROPPED, not scaled,
 *    when shown at another size (and a cropped QR scans as nothing).
 * So the namespace is added when missing and the viewBox is derived from
 * width/height. A leading XML declaration/doctype is dropped, and a complete
 * `data:` image URI passes through untouched.
 */
const SVG_NS = 'http://www.w3.org/2000/svg'

export function qrImageSrc(qr: string): string | null {
  const raw = (qr || '').trim()
  if (!raw) return null
  if (/^data:image\/(svg\+xml|png|gif|jpeg)/i.test(raw)) return raw

  const start = raw.search(/<svg[\s>]/i)
  if (start === -1) return null
  let svg = raw.slice(start)

  const open = svg.match(/<svg\b[^>]*>/i)?.[0] ?? ''
  if (!/\sxmlns\s*=/.test(open)) svg = svg.replace(/<svg\b/i, `<svg xmlns="${SVG_NS}"`)
  if (!/\sviewBox\s*=/i.test(open)) {
    const w = open.match(/\swidth\s*=\s*"?([\d.]+)/i)?.[1]
    const h = open.match(/\sheight\s*=\s*"?([\d.]+)/i)?.[1]
    if (w && h) svg = svg.replace(/<svg\b/i, `<svg viewBox="0 0 ${w} ${h}"`)
  }
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
